export default __webpack_public_path__ + "static/media/TodaySessions.19a3a2b7.png";